import { dict } from "@/dictionary";
import { z } from "zod";

export function getRequiredStrSchema(errMsg?: string) {
  return z.string().min(1, errMsg || dict.validation.isRequired);
}
